import { types as t, Instance } from 'mobx-state-tree';
import DevicePofile from '~/mst/models/device_profile';
import Fetchable from '~/mst/models/abstract/fetchable';
import CollectionMap from '~/mst/models/abstract/collection_map';

const DevicePofilesModel = t.compose(CollectionMap(DevicePofile), Fetchable({ cache: { lifeTime: 300 } }));

export interface IDevicePofilesModel extends Instance<typeof DevicePofilesModel> {}

export default DevicePofilesModel;
